import { IPublicClientApplication } from "@azure/msal-browser";
import { IUserAuthenticator } from "../../auth";
import { Language } from "../../data/constants";
import { AppRegistration } from '../../model/AppRegistration';
import { v4 as uuidv4 } from "uuid";

export type UserType = "INTERNAL" | "EXTERNAL";

export interface SessionState {
  isUserAuthenticated: boolean;
  userAuthenticator?: IUserAuthenticator;
  isLoadingAuth: boolean;
  language: Language;
  sessionId: string;
  authClient: IPublicClientApplication | null,
  appRegistration: AppRegistration | null
}

export const unloadedState: SessionState = {
  isUserAuthenticated: false,
  language: Language.DE,
  userAuthenticator: undefined,
  isLoadingAuth: true,
  sessionId: uuidv4(),
  authClient: null,
  appRegistration: null
};
